import { data } from '../../svg/Sort/data';
import { makeIcon } from '../makeIcon';

export const Sort = makeIcon(data, 'sort', 'Sort');

export default Sort;
